<template>
  <div>
    <v-card>
      <v-toolbar dense>{{ $t('configuration_title')}}</v-toolbar>

      <v-layout row wrap>
        <v-flex xs12 pa-2 v-for="(conf_segment, conf_index) in configuration" :key="conf_index">
          <v-card>
            <v-toolbar color="pink" dark flat>{{ conf_segment.title }}</v-toolbar>

            <v-card-text>
              <v-textarea
                :ref="conf_segment.segment"
                :rules="[rules.json]"
                outline
                v-model="conf_segment.conf"
                auto-grow
                validate-on-blur
              ></v-textarea>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="success"
                @click="importConf(conf_segment.segment, conf_segment.conf)"
              >{{ $t('save') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>

      <!--<v-card-text>
        <v-btn @click="importConfiguration" color="success">Reset to Standard - BE CAREFULL</v-btn>
      </v-card-text>-->
    </v-card>
  </div>
</template>

<i18n>
  {
    "de": {
      "configuration_title" : "Konfiguration",
      "save" : "Speichern"
    },
    "en": {
      "configuration_title" : "Settings",
      "save" : "Save"
    }
  }
</i18n>

<script>
import { mapActions, mapGetters } from "vuex";

import { api } from "@/store/modules/configuration";
import { api as appApi } from "@/store/modules/app";

export default {
  data() {
    return {
      rules: {
        json: v => {
          try {
            console.log("ugly", v);
            let a = JSON.parse(v);
            console.log("JSON", a);
            return true;
          } catch (e) {
            return "This field requires valid JSON input";
          }
        }
      }
    };
  },
  computed: {
    ...mapGetters(api.namespace, [
      api.getters.audit,
      api.getters.audititem,
      api.getters.finding,
      api.getters.measure,
      api.getters.user,
      api.getters.categories,
      api.getters.app,
      api.getters.lists
    ]),
    isJson(data) {
      try {
        console.log("ugly", data);
        let a = JSON.parse(data);
        console.log("JSON", a);
        return true;
      } catch (e) {
        console.log(e);
        return "This field requires valid JSON input";
      }
    },
    configuration() {
      return [
        { title: "App Settings", segment: "app", conf: this.conf_app },
        { title: "Audit Settings", segment: "audit", conf: this.conf_audit },
        {
          title: "Audititem Settings",
          segment: "audititem",
          conf: this.conf_audititem
        },
        {
          title: "Category Settings",
          segment: "categories",
          conf: this.conf_categories
        },
        {
          title: "Finding Settings",
          segment: "finding",
          conf: this.conf_finding
        },
        {
          title: "Measure Settings",
          segment: "measure",
          conf: this.conf_measure
        },
        {
          title: "User Settings",
          segment: "user",
          conf: this.conf_user
        },
        {
          title: "Listen Einstellungen",
          segment: "lists",
          conf: this.conf_lists
        }
      ];
    },
    conf_audit() {
      return JSON.stringify(this.audit, undefined, 4) || "No configuration yet";
    },
    conf_audititem() {
      return (
        JSON.stringify(this.audititem, undefined, 4) || "No configuration yet"
      );
    },
    conf_finding() {
      return (
        JSON.stringify(this.finding, undefined, 4) || "No configuration yet"
      );
    },
    conf_measure() {
      return (
        JSON.stringify(this.measure, undefined, 4) || "No configuration yet"
      );
    },
    conf_categories() {
      return (
        JSON.stringify(this.categories, undefined, 4) || "No configuration yet"
      );
    },
    conf_user() {
      return JSON.stringify(this.user, undefined, 4) || "No configuration yet";
    },
    conf_app() {
      return JSON.stringify(this.app, undefined, 4) || "No configuration yet";
    },
    conf_lists() {
      return JSON.stringify(this.lists, undefined, 4) || "No configuration yet";
    }
  },
  methods: {
    ...mapActions(api.namespace, [
      api.actions.importData,
      api.actions.updateConfiguration
    ]),
    ...mapActions(appApi.namespace, [appApi.actions.setStatus]),
    importConfiguration() {
      let dummy = { dummy: "dummy data" };
      console.log("Importing", dummy);
      this.importData(dummy);
    },
    importConf(segment, data) {
      this.setStatus("loading");
      try {
        console.log("Start Save");
        let jsondata = JSON.parse(data);
        let payload = { segment: segment, data: jsondata };

        console.log("Importing", payload);

        this.updateConfiguration(payload);
        this.setStatus("success");
      } catch (error) {
        console.log("Json Parse failed:", error);
        this.setStatus("error");
      }
    },
    preventTab(ref, e) {
      if (e.keyCode === 9) {
        // tab was pressed

        console.log("Kontext", e);
        // get caret position/selection
        let start = this.$ref.selectionStart;
        let end = this.$ref.selectionEnd;

        let me = this.$ref;
        let value = this.val();

        //set textarea value to: text before caret + tab + text after caret
        me.val(value.substring(0, start) + "\t" + value.substring(end));

        //put caret at right position again (add one for the tab)
        me.selectionStart = me.selectionEnd = start + 1;

        // prevent the focus lose
        e.preventDefault();
      }
    }
  }
};
</script>
